// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__24THM","footer":"Form_footer__1rtFS"};